"use client";
import { useGlobals } from '@/projectRoot/src/contexts/GlobalsContext';
import Button from '../../form-elements/button/Button';
import style from './toaster.module.scss';
import { useEffect } from 'react';

export interface Toast {
    id: string;
    title?: string;
    description?: string;
    initiation_time: number;
    duration_time?: number; // in milliseconds
}

interface Props {

}

const Toaster = ({}: Props) => {
    const {toasts, setToasts} = useGlobals();

    const removeFromToasts = (id: string) => {
        let newToasts = toasts.filter(toast => toast.id !== id);
        setToasts(newToasts);
    }

    useEffect(() => {
        if(toasts && toasts.length > 0){
            const interval = setInterval(() => {
                let currentTime = new Date().getTime();
                console.log(currentTime)
                let newToasts = toasts.filter(toast => (currentTime - (toast.duration_time ?? 5000)) <= toast.initiation_time);
                setToasts(newToasts);
            }, 1000);
    
            return () => {
                clearInterval(interval);
            }
        }
    }, [toasts]);

  return (
    toasts && toasts.length > 0
    ?
    <div className={style.toasts}>
        {
            toasts.map((toast, index) => 
                <div key={toast.id} className={style.toast}>
                    {
                        toast.title
                        ?
                        <p className={style.title}>{toast.title}</p>
                        : <></>
                    }
                    {
                        toast.description
                        ?
                        <div className={style.description} dangerouslySetInnerHTML={{__html: toast.description}} />
                        : <></>
                    }
                    <Button label='Ok' classes={[style.btn]} onClick={() => removeFromToasts(toast.id)} />
                </div>
            )
        }
    </div>
    : <></>
  )
};

export default Toaster;
